export default __webpack_public_path__ + "f833b9fbc90779fe309e10fa2015258c.svg";